import { render, staticRenderFns } from "./UnsubscribeLink.vue?vue&type=template&id=590c007b&"
import script from "./UnsubscribeLink.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports